<template>
  <div>
    <div v-if="!id">Please choose an album at left</div>
    <div v-if="loading">Loading...</div>
    <div v-if="loadingError">There was an error: {{loadingError.message}}</div>
    <div v-if="album">
      <AlbumEdit
        :album="album"
        :updateAlbum="updateAlbum"
        :createPage="createPage"
        :updatePageOrder="updatePageOrder"
        :deletePage="deletePage"
        :deleteAlbum="deleteAlbum"
        :route="route"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AlbumEdit from './AlbumEdit'
import { SnotifyPosition } from 'vue-snotify'
export default {
  props: ['id', 'route'],
  data() {
    return {
      album: null,
      loading: false,
      loadingError: null,
    }
  },
  mounted() {
    this.fetchAlbumData()
  },
  watch: {
    id() {
      this.fetchAlbumData()
    },
  },
  methods: {
    fetchAlbumData() {
      if (!this.id) {
        return
      }
      this.loading = true
      axios.get('/api/albums/' + this.id).then(response => {
        this.album = response.data.album
      }).catch(error => {
        this.loadingError = error.response ? error.response.data : error
      }).then(() => {
        this.loading = false
      })
    },
    updateAlbum(album) {
      this.album = { ...this.album, ...album }
    },
    updatePageOrder(orderArray) {
      axios.patch(`/api/albums/${this.album.id}/page-order`, { pageOrder: orderArray })
        .then(() => {
          this.album.pageOrders = orderArray
        })
        .catch(error => {
          this.$snotify.error('There was an error updating the page order: ' + error.message)
        })
    },
    createPage(pictureUrl) {
      return axios.post(`/api/albums/${this.album.id}/pages`, { pictureUrl })
        .then(response => {
          this.updateAlbum(response.data.album)
        })
    },
    deletePage(page) {
      this.$snotify.confirm('Are you sure you want to delete this page?', 'Are you sure?', {
        position: SnotifyPosition.centerCenter,
        backdrop: 0.67,
        buttons: [
          { text: 'Cancel' },
          {
            text: 'Yes',
            bold: true,
            action: toast => {
              return axios.delete(`/api/pages/${page.id}`)
                .then(() => {
                  this.album.pages = this.album.pages.filter(x => x.id !== page.id)
                  this.album.pageOrders = this.album.pageOrders.filter(x => x !== page.id)
                })
                .catch(error => {
                  this.$snotify.error('There was an error deleting the page: ' + error.message)
                })
                .then(() => this.$snotify.remove(toast.id))
            },
          },
        ]
      })

    },
    deleteAlbum(albumId) {
      this.$snotify.confirm('Are you sure you want to delete this album?', 'Are you sure?', {
        position: SnotifyPosition.centerCenter,
        backdrop: 0.67,
        buttons: [
          { text: 'Cancel' },
          {
            text: 'Yes',
            action: toast => {
              return axios.delete(`/api/albums/${albumId}`)
                .then(() => {
                  this.$store.commit('deleteAlbum', albumId)
                  this.$router.history.push('/dashboard')
                })
                .catch(error => {
                  this.$snotify.error('There was an error deleting the album: ' + error.message)
                })
                .then(() => this.$snotify.remove(toast.id))
            },
          },
        ]
      })
    },
  },
  components: {
    AlbumEdit,
  },
}
</script>

<style lang="stylus" scoped>

</style>
